"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.MAX_GROUPS_IN_SET=void 0;// eslint-disable-next-line import/prefer-default-export
var MAX_GROUPS_IN_SET=50;exports.MAX_GROUPS_IN_SET=MAX_GROUPS_IN_SET;